import { mainSiteUrl } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20gradient%20with%20soft%20cream%20and%20sand%20beige%20tones%2C%20gentle%20flowing%20organic%20shapes%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography%2C%20warm%20neutral%20palette%2C%20clean%20composition%2C%20no%20clutter&width=1800&height=900&seq=cta-bg-v5-unique&orientation=landscape"
          alt="Mulebuy spreadsheet shopping background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 tracking-wide uppercase leading-tight">
            Start Smart Shopping Today
          </h2>

          <p className="text-base md:text-lg text-background-50/80 mb-10 leading-relaxed max-w-xl mx-auto">
            Discover the most efficient way to shop via agent systems. The mulebuy spreadsheet method gives you full transparency and control.
          </p>

          {/* CTA Button */}
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 bg-foreground-950 text-background-50 font-bold rounded-full hover:bg-foreground-900 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm md:text-base group"
          >
            <span className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center shrink-0">
              <i className="ri-shopping-bag-line text-background-50 text-lg"></i>
            </span>
            Visit Mulebuy Now
            <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}